// src/components/GoogleWalletButton.js
import React, { useState } from 'react';
import apiClient from '../apiClient';
import { useParticipantAuth } from '../context/ParticipantAuthContext';
import './WalletButtons.css';

import googleWalletBadge from '../assets/icons/google-wallet-icon.svg';

const GoogleWalletButton = () => {
    const { programId } = useParticipantAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleAddToWalletClick = async () => {
        if (!programId) {
            setError('Program information is missing. Cannot add pass.');
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            const { data: jwt } = await apiClient.get(
                `/public/wallet/google/programs/${programId}/pass-jwt`
            );
            if (!jwt) throw new Error('Empty JWT from server.');
            window.open(`https://pay.google.com/gp/v/save/${jwt}`, '_blank', 'noopener');
        } catch (err) {
            console.error('Failed to generate Google Wallet pass:', err);
            const errorMsg = err.response?.data?.detail || err.message || 'Could not add the pass to Google Wallet.';
            setError(errorMsg);
            alert(`Error: ${errorMsg}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="google-wallet-button-container">
            <button
                onClick={handleAddToWalletClick}
                disabled={isLoading}
                className="wallet-button-svg-wrapper google-wallet-button"
                aria-label="Add to Google Wallet"
            >
                <img src={googleWalletBadge} alt="Add to Google Wallet" />
                {isLoading && <span className="spinner" />}
            </button>
            {error && <p className="wallet-button-error">{error}</p>}
        </div>
    );
};

export default GoogleWalletButton;
